(() => {
  const COOKIE_NAME = 'madorne_wishlist';
  const COOKIE_MAX_AGE_DAYS = 365;
  const HEART_PATH = 'M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z';

  const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  };

  const setCookie = (name, value, days) => {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${date.toUTCString()}; path=/; SameSite=Lax`;
  };

  const getWishlist = () => {
    const raw = getCookie(COOKIE_NAME);
    if (!raw) return [];
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  const saveWishlist = (handles) => {
    setCookie(COOKIE_NAME, JSON.stringify(handles), COOKIE_MAX_AGE_DAYS);
  };

  const isInWishlist = (handle) => getWishlist().includes(handle);

  const toggleWishlist = (handle) => {
    const list = getWishlist();
    const index = list.indexOf(handle);
    let added;

    if (index > -1) {
      list.splice(index, 1);
      added = false;
    } else {
      list.push(handle);
      added = true;
    }

    saveWishlist(list);
    syncWishlistButtons();
    updateWishlistCount();
    document.dispatchEvent(new CustomEvent('madorne:wishlist-change', { detail: { handle, added, list } }));
    return added;
  };

  const heartSvg = (filled) => {
    return `<svg viewBox="0 0 24 24" fill="${filled ? 'currentColor' : 'none'}" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="${HEART_PATH}"></path></svg>`;
  };

  const syncWishlistButtons = () => {
    const list = getWishlist();

    document.querySelectorAll('.madorne-wishlist-toggle[data-product-handle]').forEach((button) => {
      const handle = button.getAttribute('data-product-handle');
      const active = list.includes(handle);
      const wasActive = button.classList.contains('is-active');

      if (active === wasActive) return;

      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');

      const iconWrap = button.querySelector('.madorne-wishlist-toggle__icon');
      if (iconWrap) iconWrap.innerHTML = heartSvg(active);
    });
  };

  const updateWishlistCount = () => {
    const count = getWishlist().length;

    document.querySelectorAll('[data-madorne-wishlist-count]').forEach((element) => {
      element.hidden = count === 0;
      const textEl = element.querySelector('[data-madorne-wishlist-count-text]');
      if (textEl) textEl.textContent = count;
    });
  };

  const buildCardButton = (handle) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'madorne-wishlist-toggle madorne-wishlist-toggle--card';
    button.setAttribute('data-product-handle', handle);
    button.setAttribute('aria-pressed', 'false');
    button.setAttribute('aria-label', 'Add to wishlist');

    const iconWrap = document.createElement('span');
    iconWrap.className = 'madorne-wishlist-toggle__icon';
    iconWrap.innerHTML = heartSvg(false);
    button.appendChild(iconWrap);

    return button;
  };

  const injectCardButtons = (root) => {
    root.querySelectorAll('product-card[handle]').forEach((card) => {
      if (card.hasAttribute('data-wishlist-ready')) return;

      const figure = card.querySelector('.product-card__figure');
      if (!figure) return;

      const handle = card.getAttribute('handle');
      if (!handle) return;

      card.setAttribute('data-wishlist-ready', 'true');
      figure.appendChild(buildCardButton(handle));
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.madorne-wishlist-toggle');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const handle = button.getAttribute('data-product-handle');
    if (!handle) return;

    toggleWishlist(handle);
  });

  const injectStyles = () => {
    if (document.getElementById('madorne-wishlist-styles')) return;

    const style = document.createElement('style');
    style.id = 'madorne-wishlist-styles';
    style.textContent = `
      .madorne-wishlist-toggle--card {
        position: absolute;
        top: 10px;
        left: 10px;
        z-index: 2;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.85);
        border: none;
        cursor: pointer;
        color: #222;
      }

      .madorne-wishlist-toggle--card .madorne-wishlist-toggle__icon svg {
        display: block;
        width: 16px;
        height: 16px;
      }

      .madorne-wishlist-toggle--card.is-active {
        color: #c0392b;
      }

      .madorne-wishlist-header-icon svg {
        display: block;
        width: 16px;
        height: 16px;
      }
    `;
    document.head.appendChild(style);
  };

  const init = () => {
    injectStyles();
    injectCardButtons(document);
    syncWishlistButtons();
    updateWishlistCount();

    const observer = new MutationObserver((mutations) => {
      let shouldInject = false;

      for (const mutation of mutations) {
        if (mutation.addedNodes.length > 0) {
          shouldInject = true;
          break;
        }
      }

      if (shouldInject) {
        injectCardButtons(document);
        syncWishlistButtons();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.madorneWishlist = {
    get: getWishlist,
    isInWishlist,
    toggle: toggleWishlist,
    sync: syncWishlistButtons,
  };
})();
